import { SimpleAdditionalInsuranceModel } from "./additionalInsurances";

export enum RisksNetworkTypes {
    available = "AVAILABLE",
    notAvailable = "NOT_AVAILABLE",
    required = "REQUIRED"
}

export interface RisksNetworkResponseModel {
    // packages
    riskMode: {
        allRisk: RisksNetworkTypes,
        namedRisk: RisksNetworkTypes
    };
    fireAndRandomEvents: {
        detachedHouseOrFlat: RisksNetworkTypes,
        onlyFixedElements: RisksNetworkTypes,
        movables: RisksNetworkTypes
    };
    additionalRisks: {
        buildingToolsAndMaterials: RisksNetworkTypes,
        devastation: RisksNetworkTypes,
        searchingAndRemovingCauseOfDamage: RisksNetworkTypes,
        theft: RisksNetworkTypes,
        surges: RisksNetworkTypes,
        windowpanes: RisksNetworkTypes
    };
    flood: RisksNetworkTypes;
    burglaryAndTheft: {
        fixedElements: RisksNetworkTypes,
        movables: RisksNetworkTypes
    };
    assistance: RisksNetworkTypes;
    // additionalRisks
    secondOpinion: {
        standard: RisksNetworkTypes,
        familyExtension: RisksNetworkTypes
    };
    catAndDog: RisksNetworkTypes;
    safeSenior: RisksNetworkTypes;
    ocInPrivateLife: {
        standard: RisksNetworkTypes,
        additionalPropertyExtension: RisksNetworkTypes,
        childExtension: RisksNetworkTypes,
        renterExtension: RisksNetworkTypes
    };
    gravestone: RisksNetworkTypes;
    legalProtection: RisksNetworkTypes;
    nnw: RisksNetworkTypes;
    greenEnergySources: RisksNetworkTypes;
    nonResidentialBuildings: RisksNetworkTypes;
    propertyFixedElements: RisksNetworkTypes;
    // additionalQuestions
    insuranceDuration: {
        months12: RisksNetworkTypes,
        months36: RisksNetworkTypes
    };
}

export function displayAdditionalRiskForm(risk: SimpleAdditionalInsuranceModel) {
    return risk.risksNetworkValue === RisksNetworkTypes.required ||
        (risk.risksNetworkValue === RisksNetworkTypes.available && risk.checked);
}
